// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
body {
    height: 100%;
    margin: 0;
}

.page-container {
    display: flex;
    flex-direction: column;
    min-height: 100%;
  }

.products-page-content-desktop {
    flex: 1 1;
    /* Allow the content to grow and take available space */
    padding: 20px;
    overflow-y: auto;
    /* Enable vertical scrolling if needed */
    height: 100%;
    /* Set height to 100% */
    padding: 20px;
    box-sizing: border-box;
}

.products-page-content-mobile {
    flex: 1 1;
    /* Allow the content to grow and take available space */
    overflow-y: auto;
    /* Enable vertical scrolling if needed */
    height: 100%;
    /* Set height to 100% */
    box-sizing: border-box;
}

.products-page {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    height: max-content;
}


.standard-row {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin: 10px;
}

.standard-row>* {
    padding: 20px;
}

.manufacturer-list {
    display: flex;
    flex-direction: column;
    margin: 1px;
}

.manufacturer-item {
    margin: 10px;
}

table.product-table {
    width: 100%;
    display: table;
    border: 1px solid #ccc;
    background-color: #fff;
    margin: 10px;
    
  }
  table.product-table th,
  table.product-table td{
    overflow-wrap: break-word;
    word-wrap: break-word;
    word-break: break-all;
  } 
  .product-actions-desktop {
    display: flex;
    flex-direction: row;
  }
  .product-actions-mobile {
    display: flex;
    flex-direction: column;
  }
  table.product-table td:first-child {
    width: 35%;
    overflow-wrap: break-word;
    word-wrap: break-word;
    word-break: break-all;
  }
  .center {
    overflow-wrap: break-word;
    word-wrap: break-word;
    word-break: break-all;
  }

  .mobile-product-tile{
    height: 100%;
    width: 100%;
    max-width: 70vw;
    max-height: -moz-fit-content;
    max-height: fit-content;
    min-height: 10vh;
    background-color: #334191;
    color: #fff;
    display: flex;
    flex-direction:row;
    align-items:center;
    justify-content: space-around;
  }

  .mobile-product-tile-expanded {
    height: 100%;
    width: 100%;
    max-width: 70vw;
    max-height: -moz-fit-content;
    max-height: fit-content;
    background-color: #334191;
    color: #fff;
    align-items:center;
    justify-content: space-around;
  }

 table.product-table-expanded{
  align-self: center;
  align-items: center;
  border-collapse: collapse;
  border-spacing: 0;
  width: 80%;
  display: table;
  margin: 10px;
  }
  table.product-table-expanded th,
  table.product-table-expanded td:first-child{
    width: 35%;
    overflow-wrap: break-word;
    word-wrap: break-word;
  }    `, "",{"version":3,"sources":["webpack://./src/css/pages/Products.css"],"names":[],"mappings":";AACA;IACI,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;EAClB;;AAEF;IACI,SAAO;IACP,uDAAuD;IACvD,aAAa;IACb,gBAAgB;IAChB,wCAAwC;IACxC,YAAY;IACZ,uBAAuB;IACvB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,SAAO;IACP,uDAAuD;IACvD,gBAAgB;IAChB,wCAAwC;IACxC,YAAY;IACZ,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,sBAAsB;IACtB,sBAAsB;IACtB,YAAY;;EAEd;EACA;;IAEE,yBAAyB;IACzB,qBAAqB;IACrB,qBAAqB;EACvB;EACA;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,yBAAyB;IACzB,qBAAqB;IACrB,qBAAqB;EACvB;EACA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,qBAAqB;EACvB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,eAAe;IACf,4BAAuB;IAAvB,uBAAuB;IACvB,gBAAgB;IAChB,yBAAyB;IACzB,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,6BAA6B;EAC/B;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,eAAe;IACf,4BAAuB;IAAvB,uBAAuB;IACvB,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,6BAA6B;EAC/B;;CAED;EACC,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,UAAU;EACV,cAAc;EACd,YAAY;EACZ;EACA;;IAEE,UAAU;IACV,yBAAyB;IACzB,qBAAqB;EACvB","sourcesContent":["\r\nbody {\r\n    height: 100%;\r\n    margin: 0;\r\n}\r\n\r\n.page-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    min-height: 100%;\r\n  }\r\n\r\n.products-page-content-desktop {\r\n    flex: 1;\r\n    /* Allow the content to grow and take available space */\r\n    padding: 20px;\r\n    overflow-y: auto;\r\n    /* Enable vertical scrolling if needed */\r\n    height: 100%;\r\n    /* Set height to 100% */\r\n    padding: 20px;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.products-page-content-mobile {\r\n    flex: 1;\r\n    /* Allow the content to grow and take available space */\r\n    overflow-y: auto;\r\n    /* Enable vertical scrolling if needed */\r\n    height: 100%;\r\n    /* Set height to 100% */\r\n    box-sizing: border-box;\r\n}\r\n\r\n.products-page {\r\n    flex: 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: max-content;\r\n}\r\n\r\n\r\n.standard-row {\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: center;\r\n    align-items: center;\r\n    margin: 10px;\r\n}\r\n\r\n.standard-row>* {\r\n    padding: 20px;\r\n}\r\n\r\n.manufacturer-list {\r\n    display: flex;\r\n    flex-direction: column;\r\n    margin: 1px;\r\n}\r\n\r\n.manufacturer-item {\r\n    margin: 10px;\r\n}\r\n\r\ntable.product-table {\r\n    width: 100%;\r\n    display: table;\r\n    border: 1px solid #ccc;\r\n    background-color: #fff;\r\n    margin: 10px;\r\n    \r\n  }\r\n  table.product-table th,\r\n  table.product-table td{\r\n    overflow-wrap: break-word;\r\n    word-wrap: break-word;\r\n    word-break: break-all;\r\n  } \r\n  .product-actions-desktop {\r\n    display: flex;\r\n    flex-direction: row;\r\n  }\r\n  .product-actions-mobile {\r\n    display: flex;\r\n    flex-direction: column;\r\n  }\r\n  table.product-table td:first-child {\r\n    width: 35%;\r\n    overflow-wrap: break-word;\r\n    word-wrap: break-word;\r\n    word-break: break-all;\r\n  }\r\n  .center {\r\n    overflow-wrap: break-word;\r\n    word-wrap: break-word;\r\n    word-break: break-all;\r\n  }\r\n\r\n  .mobile-product-tile{\r\n    height: 100%;\r\n    width: 100%;\r\n    max-width: 70vw;\r\n    max-height: fit-content;\r\n    min-height: 10vh;\r\n    background-color: #334191;\r\n    color: #fff;\r\n    display: flex;\r\n    flex-direction:row;\r\n    align-items:center;\r\n    justify-content: space-around;\r\n  }\r\n\r\n  .mobile-product-tile-expanded {\r\n    height: 100%;\r\n    width: 100%;\r\n    max-width: 70vw;\r\n    max-height: fit-content;\r\n    background-color: #334191;\r\n    color: #fff;\r\n    align-items:center;\r\n    justify-content: space-around;\r\n  }\r\n\r\n table.product-table-expanded{\r\n  align-self: center;\r\n  align-items: center;\r\n  border-collapse: collapse;\r\n  border-spacing: 0;\r\n  width: 80%;\r\n  display: table;\r\n  margin: 10px;\r\n  }\r\n  table.product-table-expanded th,\r\n  table.product-table-expanded td:first-child{\r\n    width: 35%;\r\n    overflow-wrap: break-word;\r\n    word-wrap: break-word;\r\n  }    "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
